export enum Gender {
  M = 'M',
  F = 'F',
}
